import React from 'react';

import { ReactComponent as Arrow } from '../../../images/icons/fs-lc-arrow.svg';
import ContentfulImage from '../ContentfulImage';
import SmartLink from '../SmartLink';
import * as styles from './SideScroll.module.scss';

export default function Cards({ content, contentRef = null, cardIsClickable = true }) {
  return (
    <div className={styles.cards} ref={contentRef}>
      {cardIsClickable ? (
        content.map((card, i) => (
          <SmartLink
            to={card.ctaUrl}
            key={i}
            className={styles.card}
            data-analytics-id={card.title}
            data-analytics-component={'scrolling-card'}
          >
            <ContentfulImage lazy={true} className={styles.backgroundImage} imageFragment={card.mainImage} />
            <img className={styles.logo} src={card.logo?.file?.url} alt={card.logo?.description || card.title} />
            <h3 className={styles.title}>{card.title}</h3>
            <div className={styles.cta}>
              {card.ctaLabel}
              <Arrow />
            </div>
          </SmartLink>
        ))
      ) : (
        <>
          {content.map((card, i) => (
            <div
              key={i}
              className={styles.card}
              data-analytics-id={card.title}
              data-analytics-component={'scrolling-card'}
            >
              <ContentfulImage lazy={true} className={styles.backgroundImage} imageFragment={card.mainImage} />
              <img className={styles.logo} src={card.logo?.file?.url} alt={card.logo?.description || card.title} />
              <h3 className={styles.title}>{card.title}</h3>
              <SmartLink to={card.ctaUrl} className={styles.cta}>
                {card.ctaLabel}
                <Arrow />
              </SmartLink>
            </div>
          ))}
          <div className={styles.spacer} />
        </>
      )}
    </div>
  );
}
